export default __webpack_public_path__ + "static/media/Stalwart Ring.e6142ff0.jpg";